import Beats from './Beats';

export default Beats;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullECGPreview/Beats/index.js